import { useEffect, useState } from "react";
import { tt, dir } from "@/lib/i18n";
import { useLang } from "@/context/lang-context";

// صفحة التحميل بهوية جسر — تنفيذ حرفي لتصميم Claude Design «Loading Page»
// (النسخة الفاتحة): الشعار يتنفس + أعمدة إيكولايزر متدرجة الألوان + مسار
// تقدم بتدرج bridge + رسائل تتبدل كل 2.4 ثانية بنقاط نابضة.
const MESSAGES = ["جاري التحميل", "نجهّز صندوق الوارد", "نزامن المحادثات", "لحظات ويكتمل التحميل"];
const BARS = [
  { color: "#19C37D", delay: "0s" },
  { color: "#16A46C", delay: "-0.15s" },
  { color: "#0F5B63", delay: "-0.3s" },
  { color: "#16A46C", delay: "-0.45s" },
  { color: "#19C37D", delay: "-0.6s" },
];

export function LoadingPage() {
  useLang();
  const [msgIndex, setMsgIndex] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setMsgIndex((i) => (i + 1) % MESSAGES.length), 2400);
    return () => clearInterval(t);
  }, []);

  return (
    <div
      dir={dir()}
      style={{
        minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", gap: 36, background: "#F8FAFC", position: "relative", overflow: "hidden",
      }}
    >
      <style>{`
        @keyframes jisr-bar { 0%,100%{transform:scaleY(.35);opacity:.55} 50%{transform:scaleY(1);opacity:1} }
        @keyframes jisr-logo-in { from{opacity:0;transform:translateY(10px) scale(.97)} to{opacity:1;transform:translateY(0) scale(1)} }
        @keyframes jisr-breathe { 0%,100%{transform:scale(1)} 50%{transform:scale(1.03)} }
        @keyframes jisr-track { 0%{transform:translateX(100%)} 100%{transform:translateX(-250%)} }
        @keyframes jisr-msg { 0%{opacity:0;transform:translateY(6px)} 12%,82%{opacity:1;transform:translateY(0)} 100%{opacity:0;transform:translateY(-6px)} }
        @keyframes jisr-dot { 0%,100%{opacity:.25} 50%{opacity:1} }
      `}</style>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 28, position: "relative", animation: "jisr-logo-in .6s cubic-bezier(.16,1,.3,1) both" }}>
        <div style={{ animation: "jisr-breathe 3.2s ease-in-out infinite" }}>
          <img src="/brand/jisr-mark.png" alt={tt("جسر")} style={{ width: 168, display: "block" }} />
        </div>
        <div style={{ display: "flex", alignItems: "flex-end", gap: 7, height: 34, direction: "ltr" }}>
          {BARS.map((b, i) => (
            <div key={i} style={{ width: 7, height: 34, borderRadius: 99, background: b.color, transformOrigin: "bottom", animation: `jisr-bar 1.1s ease-in-out ${b.delay} infinite` }} />
          ))}
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 14 }}>
        <div style={{ width: 220, height: 4, borderRadius: 99, background: "#E2E8F0", overflow: "hidden", position: "relative" }}>
          <div style={{ position: "absolute", inset: 0, width: "45%", borderRadius: 99, background: "linear-gradient(90deg,#0F5B63,#19C37D)", animation: "jisr-track 1.6s cubic-bezier(.45,0,.55,1) infinite" }} />
        </div>
        <div style={{ height: 22, position: "relative", minWidth: 260, textAlign: "center" }}>
          <div key={msgIndex} style={{ fontSize: 14, fontWeight: 500, color: "#475569", animation: "jisr-msg 2.4s ease infinite", display: "flex", justifyContent: "center", gap: 4 }}>
            <span>{tt(MESSAGES[msgIndex])}</span>
            <span style={{ animation: "jisr-dot 1s ease-in-out 0s infinite" }}>.</span>
            <span style={{ animation: "jisr-dot 1s ease-in-out .2s infinite" }}>.</span>
            <span style={{ animation: "jisr-dot 1s ease-in-out .4s infinite" }}>.</span>
          </div>
        </div>
      </div>

      <div style={{ position: "absolute", bottom: 28, fontSize: 12, color: "#94A3B8", letterSpacing: 0.2 }}>{tt("جسر")} · Jisr</div>
    </div>
  );
}
